<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
    />
    <div v-if="readOnly">
      {{ value }}
    </div>
    <template v-else>
      <AppTooltip trigger="click" :container="false">
        <div class="position-relative">
          <input
            :id="id"
            ref="input"
            :value="value"
            type="text"
            :placeholder="disabled ? '—' : placeholder"
            :disabled="disabled"
            :invalid="invalid && dirty"
            class="form-control"
            readonly
          />
          <div
            class="pigment"
            :style="{ background: value }"
          />
        </div>
        <template #tooltip>
          <ColorPicker
            :value="value || ''"
            @input="update($event.hex)"
          />
        </template>
      </AppTooltip>
    </template>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
import FormLabel from './FormLabel'
import FormMixin from './FormMixin'

export default {
  mixins: [ FormMixin ],
  components: { FormLabel, ColorPicker: Chrome },
}
</script>

<style scoped>
.form-control[readonly] {
  background: transparent;
}

.pigment {
  position: absolute;
  right: 10px;
  top: 9px;
  height: 15px;
  width: 15px;
  border-radius: 100%;
}
</style>
